import * as Api from '@ViewModels';
import equal from 'fast-deep-equal';

/**
 * Gets user from ownership filter
 * @source Original location: UiUtils.ts.backup line 2834
 */
export const getUserFromOwnershipFilter = (filter?: Api.IOwnershipFilter) => {
	return filter?.criteria?.property === Api.ContactFilterCriteriaProperty.OwnedBy ? filter.criteria.value : null;
};

/**
 * Checks if ownership filters are equal
 * @source Original location: UiUtils.ts.backup line 2838
 */
export const areOwnershipFiltersEqual = (
	currentUserId: string,
	a: Api.IOwnershipFilter | null,
	b: Api.IOwnershipFilter | null
) => {
	if (!a && !b) {
		return true;
	}

	if (!a || !b) {
		return false;
	}

	const isOwnedBy =
		a.criteria.property === Api.ContactFilterCriteriaProperty.OwnedBy &&
		b.criteria.property === Api.ContactFilterCriteriaProperty.OwnedBy;

	const isMyConnections =
		a.criteria.property === Api.ContactFilterCriteriaProperty.Connections &&
		b.criteria.property === Api.ContactFilterCriteriaProperty.Connections;

	if (isOwnedBy || isMyConnections) {
		if (a.criteria.values || b.criteria.values) {
			return equal(a.criteria.values, b.criteria.values);
		}

		// no value and current user id are equivalent
		if (
			(!a.criteria.value || a.criteria.value.length === 0 || a.criteria.value === currentUserId) &&
			(!b.criteria.value || b.criteria.value.length === 0 || b.criteria.value === currentUserId)
		) {
			return true;
		}

		return a.criteria.value === b.criteria.value;
	}

	return equal(a.criteria, b.criteria);
};

/**
 * Checks if ownership dropdown should be disabled
 * @source Original location: UiUtils.ts.backup line 2872
 */
export const shouldDisableOwnershipDropdown = (disable: boolean, sendFrom?: Api.ISendOnBehalfPermission) => {
	if (disable || sendFrom?.requiredFilter) {
		return true;
	}

	return sendFrom?.sender && sendFrom.sender.mode === Api.SendEmailFrom.ContactOwner;
};

export const isMetaAdsAllowedAccount = (accountId: string | undefined): boolean => {
	if (!accountId) {
		return false;
	}
	return (
		accountId === import.meta.env.VITE_MAIN_LEV_ACCOUNT_ID ||
		accountId === import.meta.env.VITE_MAIN_META_TEST_ACCOUNT_ID
	);
};
